import React from 'react';
import { handleActions } from 'redux-actions';
import * as ActionTypes from '../../../constants/ActionTypes';
import { merge, set as setPath } from 'lodash';

const initialState = {
    general: {
        primaryBackgroundColor: '#CCCCCC',
        secondaryBackgroundColor: '#CCCCCC'
    },
    heading: {
        size: '32px',
        color: '#000000',
        style: 'normal',
        weight: 'normal',
        decoration: 'none',
        lineHeight: '1.0',
        align: 'left',
        font: 'IBM Plex sans'
    },
    subheading: {
        size: '24px',
        color: '#000000',
        style: 'normal',
        weight: 'normal',
        decoration: 'none',
        lineHeight: '1.0',
        align: 'left',
        font: 'IBM Plex sans'
    },
    subtitle: {
        size: '16px',
        color: '#000000',
        style: 'normal',
        weight: 'bold',
        decoration: 'none',
        lineHeight: '1.0',
        align: 'left',
        font: 'IBM Plex sans'
    },
    body: {
        size: '16px',
        color: '#000000',
        style: 'normal',
        weight: 'normal',
        decoration: 'none',
        lineHeight: '1.0',
        align: 'left',
        font: 'IBM Plex sans'
    },
    smallBody: {
        size: '12px',
        color: '#000000',
        style: 'normal',
        weight: 'normal',
        decoration: 'none',
        lineHeight: '1.0',
        align: 'left',
        font: 'IBM Plex sans'
    },
    price: {
        size: '16px',
        color: '#000000',
        style: 'normal',
        weight: 'normal',
        decoration: 'none',
        lineHeight: '1.0',
        align: 'left',
        font: 'IBM Plex Sans'
    },
    divider: {
        color: '#B7B7B7',
        style: 'solid',
        width: '1px'
    },
    border: {
        color: '#B7B7B7',
        style: 'solid',
        width: '1px'
    }
};

const globalDataReducer = handleActions(
    {
        [ActionTypes.THEME_GLOBAL_SET_THEME_FONT]: (state, action) => {
            let obj = {
                h1: {
                    ...state.h1
                },
                h2: {
                    ...state.h2
                },
                h3: {
                    ...state.h3
                },
                h4: {
                    ...state.h4
                },
                h5: {
                    ...state.h5
                }
            };
            if (action.layer === 'heading') {
                obj['h1'] = { ...state['h1'], fontFamily: action.font };
            } else if (action.layer === 'modalheading') {
                obj['h2'] = { ...state['h2'], fontFamily: action.font };
            } else if (action.layer === 'subheading') {
                obj['h3'] = { ...state['h3'], fontFamily: action.font };
            } else if (action.layer === 'subtitle') {
                obj['h4'] = { ...state['h4'], fontFamily: action.font };
            } else if (action.layer === 'body') {
                obj['h5'] = { ...state['h5'], fontFamily: action.font };
            } else if (action.layer === 'smallBody') {
                obj['font'] = { ...state['font'], main: action.font };
            }
            obj[action.layer] = { ...state[action.layer], font: action.font };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_GLOBAL_SET_THEME_FONT_SIZE]: (state, action) => {
            let obj = {
                h1: {
                    ...state.h1
                },
                h2: {
                    ...state.h2
                },
                h3: {
                    ...state.h3
                },
                h4: {
                    ...state.h4
                },
                h5: {
                    ...state.h5
                }
            };
            if (action.layer === 'heading') {
                obj['h1'] = { ...state['h1'], fontSize: action.size };
            } else if (action.layer === 'modalheading') {
                obj['h2'] = { ...state['h2'], fontSize: action.size };
            } else if (action.layer === 'subheading') {
                obj['h3'] = { ...state['h3'], fontSize: action.size };
            } else if (action.layer === 'subtitle') {
                obj['h4'] = { ...state['h4'], fontSize: action.size };
            } else if (action.layer === 'body') {
                obj['h5'] = { ...state['h5'], fontSize: action.size };
            } else if (action.layer === 'smallBody') {
                obj['font'] = { ...state['font'], baseSize: action.size };
            }
            obj[action.layer] = { ...state[action.layer], size: action.size };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_GLOBAL_SET_THEME_FONT_WEIGHT]: (state, action) => {
            let obj = {
                h1: {
                    ...state.h1
                },
                h2: {
                    ...state.h2
                },
                h3: {
                    ...state.h3
                },
                h4: {
                    ...state.h4
                },
                h5: {
                    ...state.h5
                }
            };
            if (action.layer === 'heading') {
                obj['h1'] = { ...state['h1'], fontWeight: action.weight };
            } else if (action.layer === 'modalheading') {
                obj['h2'] = { ...state['h2'], fontWeight: action.weight };
            } else if (action.layer === 'subheading') {
                obj['h3'] = { ...state['h3'], fontWeight: action.weight };
            } else if (action.layer === 'subtitle') {
                obj['h4'] = { ...state['h4'], fontWeight: action.weight };
            } else if (action.layer === 'body') {
                obj['h5'] = { ...state['h5'], fontWeight: action.weight };
            } else if (action.layer === 'smallBody') {
                obj['font'] = { ...state['font'], normalWeight: action.weight };
            }
            obj[action.layer] = { ...state[action.layer], weight: action.weight };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_GLOBAL_SET_THEME_FONT_STYLE]: (state, action) => {
            let obj = {};
            obj[action.layer] = { ...state[action.layer], style: action.style };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_GLOBAL_SET_THEME_FONT_COLOR]: (state, action) => {
            let obj = {
                h1: {
                    ...state.h1
                },
                h2: {
                    ...state.h2
                },
                h3: {
                    ...state.h3
                },
                h4: {
                    ...state.h4
                },
                h5: {
                    ...state.h5
                }
            };
            if (action.layer === 'heading') {
                obj['h1'] = { ...state['h1'], color: action.color };
            } else if (action.layer === 'modalheading') {
                obj['h2'] = { ...state['h2'], color: action.color };
            } else if (action.layer === 'subheading') {
                obj['h3'] = { ...state['h3'], color: action.color };
            } else if (action.layer === 'subtitle') {
                obj['h4'] = { ...state['h4'], color: action.color };
            } else if (action.layer === 'body') {
                obj['h5'] = { ...state['h5'], color: action.color };
            } else if (action.layer === 'smallBody') {
                obj['font'] = { ...state['font'], color: action.color };
            }
            obj[action.layer] = { ...state[action.layer], color: action.color };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_GLOBAL_SET_THEME_TEXT_DECORATION]: (state, action) => {
            let obj = {
                h1: {
                    ...state.h1
                },
                h2: {
                    ...state.h2
                },
                h3: {
                    ...state.h3
                },
                h4: {
                    ...state.h4
                },
                h5: {
                    ...state.h5
                }
            };
            if (action.layer === 'heading') {
                obj['h1'] = { ...state['h1'], textTransform: action.decoration };
            } else if (action.layer === 'modalheading') {
                obj['h2'] = { ...state['h2'], textTransform: action.decoration };
            } else if (action.layer === 'subheading') {
                obj['h3'] = { ...state['h3'], textTransform: action.decoration };
            } else if (action.layer === 'subtitle') {
                obj['h4'] = { ...state['h4'], textTransform: action.decoration };
            } else if (action.layer === 'body') {
                obj['h5'] = { ...state['h5'], textTransform: action.decoration };
            } else if (action.layer === 'smallBody') {
                obj['font'] = { ...state['font'] };
            }
            obj[action.layer] = { ...state[action.layer], textTransform: action.decoration };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_GLOBAL_SET_THEME_BORDER_WIDTH]: (state, action) => {
            let obj = {};
            obj[action.layer] = { ...state[action.layer], width: action.width };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_GLOBAL_SET_THEME_LINE_HEIGHT]: (state, action) => {
            let obj = {
                h1: {
                    ...state.h1
                },
                h2: {
                    ...state.h2
                },
                h3: {
                    ...state.h3
                },
                h4: {
                    ...state.h4
                },
                h5: {
                    ...state.h5
                }
            };
            if (action.layer === 'heading') {
                obj['h1'] = { ...state['h1'], lineHeight: action.lineHeight };
            } else if (action.layer === 'modalheading') {
                obj['h2'] = { ...state['h2'], lineHeight: action.lineHeight };
            } else if (action.layer === 'subheading') {
                obj['h3'] = { ...state['h3'], lineHeight: action.lineHeight };
            } else if (action.layer === 'subtitle') {
                obj['h4'] = { ...state['h4'], lineHeight: action.lineHeight };
            } else if (action.layer === 'body') {
                obj['h5'] = { ...state['h5'], lineHeight: action.lineHeight };
            } else if (action.layer === 'smallBody') {
                obj['font'] = { ...state['font'], lineHeight: action.lineHeight };
            }
            obj[action.layer] = { ...state[action.layer], lineHeight: action.lineHeight };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_GLOBAL_SET_THEME_TEXT_ALIGN]: (state, action) => {
            let obj = {};
            obj[action.layer] = { ...state[action.layer], align: action.align };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_GLOBAL_SET_THEME_BORDER_STYLE]: (state, action) => {
            let obj = {};
            obj[action.layer] = { ...state[action.layer], style: action.style };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_GLOBAL_SET_THEME_PRIMARY_BACKGROUND_COLOR]: (state, action) => {
            let obj = {
                global: {
                    ...state.global
                }
            };
            if (action.layer === 'general') {
                obj['global'] = { ...state.global, primaryBackgroundColor: action.primaryBackgroundColor };
            }
            obj[action.layer] = { ...state[action.layer], primaryBackgroundColor: action.primaryBackgroundColor };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_GLOBAL_SET_THEME_SECONDARY_BACKGROUND_COLOR]: (state, action) => {
            let obj = {
                global: {
                    ...state.global
                }
            };
            if (action.layer === 'general') {
                obj['global'] = { ...state.global, secondaryBackgroundColor: action.secondaryBackgroundColor };
            }
            obj[action.layer] = { ...state[action.layer], secondaryBackgroundColor: action.secondaryBackgroundColor };
            return { ...state, ...obj };
        },
        [ActionTypes.LOGIN_SET_THEME]: (state, action) => {
            if (action.theme.hasOwnProperty('h1')) {
                return {
                    ...state,
                    h1: action.theme.h1,
                    h2: action.theme.h2,
                    h3: action.theme.h3,
                    h4: action.theme.h4,
                    h5: action.theme.h5,
                    font: action.theme.font
                };
            } else {
                return state;
            }
        },
        //TODO: temporary partial implementation of global reducer
        [ActionTypes.THEME_MODIFY_KEY]: (state, action) => {
            let pathCheck = action.path.split('.');
            if (pathCheck[0] === 'global') {
                pathCheck.shift();
                return merge({}, state, setPath({}, pathCheck, action.value));
            } else {
                return state;
            }
        }
    },
    initialState
);

export default globalDataReducer;



// WEBPACK FOOTER //
// ./src/reducers/theme/data/global.js